export default __webpack_public_path__ + "static/footer_bg-bdf2d4cfd8343b0ad539afec800d8747.png";